<template>
  <div class="signup pa-12 bg-light-gray fill-height d-flex justify-center align-center">
    <v-card elevation="4">
      <v-row class="no-gutters">
        <v-col
          v-if="!$vuetify.breakpoint.xs"
          cols="4"
          class="d-flex justify-center align-center bg-light-green white--text"
        >
          <v-row class="no-gutters pa-2 text-center">
            <div class="text-center ma-auto">
              <span :class="{ 'fs-25': $vuetify.breakpoint.xs, 'fs-30': !$vuetify.breakpoint.xs }"
                >Welcome to <b>Web Impex</b></span
              >
            </div>
            <div class="pa-6 pt-2">
              <span class="subtitle-1">
                If you have already created an account please click the button below and login with your credentials
              </span>
            </div>
            <div class="text-center ma-auto">
              <v-btn color="white" class="primary--text" @click="$router.push({ name: 'auth.login' })">Sign In</v-btn>
            </div>
            <div class="pa-6">
              <span class="subtitle-1">
                You can view the instructions to register into the application by clicking
                <b>LEARN TO USE</b>
                or you can seek for support from our talented support team by calling <b>(+91) 9712934085</b> or
                emailing us at
                <b>info@todoitservices.com</b>
              </span>
            </div>
            <div class="text-center ma-auto">
              <v-btn color="white" class="primary--text" @click="learnToUseDoc()">LEARN TO USE</v-btn>
            </div>
          </v-row>
        </v-col>
        <v-col :cols="dynamicCol">
          <div class="signup-container" :class="containerWidth">
            <div
              :class="{
                'fs-25': $vuetify.breakpoint.xs,
                'fs-30': !$vuetify.breakpoint.xs,
                'text-center': true,
                'mb-3': true
              }"
            >
              Register your Organisation
            </div>
            <ValidationObserver v-slot="{ passes }">
              <v-row>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <TextField
                    v-model="firstName"
                    showIcons
                    :showOnlyErrorIcons="true"
                    rules="required"
                    :loading="isSignupFormLoading"
                    label="First Name"
                  />
                </v-col>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <TextField
                    v-model="lastName"
                    rules="required"
                    showIcons
                    :showOnlyErrorIcons="true"
                    :loading="isSignupFormLoading"
                    label="Last Name"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <TextField
                    v-model="email"
                    showIcons
                    :showOnlyErrorIcons="true"
                    rules="required|email"
                    :loading="isSignupFormLoading"
                    label="Email"
                  />
                </v-col>
                <v-col>
                  <TextField
                    v-model="companyName"
                    rules="required"
                    showIcons
                    :showOnlyErrorIcons="true"
                    :loading="isSignupFormLoading"
                    label="Company Name"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <TextField
                    v-model="password"
                    showIcons
                    :showOnlyErrorIcons="true"
                    rules="required"
                    :loading="isSignupFormLoading"
                    label="Password"
                    type="password"
                  />
                </v-col>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <TextField
                    v-model="confirmPassword"
                    showIcons
                    :showOnlyErrorIcons="true"
                    rules="required|confirmed:Password"
                    :loading="isSignupFormLoading"
                    label="Confirm Password"
                    type="password"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <TextField
                    v-model="icegateID"
                    rules="required"
                    showIcons
                    :showOnlyErrorIcons="true"
                    :loading="isSignupFormLoading"
                    label="Icegate ID"
                  />
                </v-col>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <TextField
                    v-model="chaLicenseNumber"
                    showIcons
                    :showOnlyErrorIcons="true"
                    rules="required"
                    :loading="isSignupFormLoading"
                    label="CHA License Number"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <TextField
                    v-model="chaRegisteredAddress"
                    showIcons
                    :showOnlyErrorIcons="true"
                    rules="required"
                    :loading="isSignupFormLoading"
                    label="CHA Registered Address"
                  />
                </v-col>
              </v-row>
              <v-btn
                color="button-primary"
                large
                class="white--text my-3"
                block
                :loading="isSignupFormLoading"
                @click="passes(signUp)"
              >
                <span class="font-weight-bold fs-15">Create an Account</span>
              </v-btn>
            </ValidationObserver>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
// import GauravImpexLogo from "@/components/GauravImpexLogo";
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import { SIGN_UP } from "@/modules/AuthModule/store/actionTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";

export default {
  name: "SignUp",
  components: {
    // GauravImpexLogo,
    ValidationObserver,
    TextField
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      companyName: "",
      icegateID: "",
      chaLicenseNumber: "",
      chaRegisteredAddress: "",
      isSignupFormLoading: false
    };
  },
  computed: {
    dynamicCol() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      } else {
        return 8;
      }
    }
  },
  mixins: [commonMethodsMixin],
  methods: {
    signUp() {
      const signUpData = {
        name: this.firstName + " " + this.lastName,
        email: this.email,
        password: this.password,
        confirmPassword: this.confirmedPassword,
        company_name: this.companyName,
        icegate_id: this.icegateID,
        cha_license_number: this.chaLicenseNumber,
        cha_address: this.chaRegisteredAddress
      };
      this.isSignupFormLoading = true;
      this.$store
        .dispatch(SIGN_UP, signUpData)
        .then(() => this.$router.push({ name: "dashboard.home" }))
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => (this.isSignupFormLoading = false));
    }
  }
};
</script>
<style lang="scss">
.signup {
  .signup-container {
    margin: 3rem auto;

    .description {
      font-size: 1.3rem;
      font-weight: 600;
    }

    .form-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
.bg-light-gray {
  background-color: #fbfbfb;
}
.bg-light-green {
  background-color: #22cd6a;
}
</style>
